var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "xmlbovpsaa",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.613917 0 0 0 0 0.678458 0 0 0 0 0.746796 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#xmlbovpsaa)",
    transform: "translate(-40.000000, -328.000000) translate(0.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A4AAC4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.481 4.042c.486 0 .884.398.884.885s-.398.886-.884.886H2.155c-.216 0-.388.172-.388.388v15.64c0 .216.172.388.388.388h15.607c.216 0 .387-.172.387-.389v-8.004c0-.487.398-.885.884-.885s.884.398.884.885v8.004c0 1.19-.967 2.16-2.155 2.16H2.155C.967 24 0 23.03 0 21.84V6.201c0-1.19.967-2.16 2.155-2.16zM17.516.534c.506-.516 1.046-.566 1.409-.521l.079.01c.314.034.672.078 1.03.226 1.665.674 2.882 1.87 3.619 3.552.132.295.191.585.245.846.02.098.04.197.074.275.024.099.034.202.024.3-.044.473-.226.866-.555 1.196-3.53 3.532-7.211 7.217-11.247 11.27-.26.266-.569.433-.942.512-1.35.285-2.72.576-4.05.856l-.8.167c-.103.025-.207.035-.31.035-.368 0-.712-.138-.967-.394-.324-.325-.456-.802-.358-1.274l.162-.768c.285-1.357.58-2.76.879-4.137.103-.477.574-.777 1.05-.674.476.104.776.576.673 1.053-.3 1.373-.594 2.77-.879 4.123l-.04.182.212-.045 4.055-.856c.034-.01.034-.01.054-.03 3.108-3.117 6-6.017 8.78-8.797l2.491-2.492-.03-.143c-.038-.192-.078-.369-.132-.497-.554-1.26-1.423-2.12-2.665-2.622-.143-.06-.359-.084-.585-.113h-.014c-2.155 2.17-4.34 4.358-6.456 6.479l-1.551 1.554-.355.356-.108.108-.102.102-.037.038-.048.048-.033.032-.048.049c-.079.08-.225.232-.536.546-.343.35-.903.355-1.252.01-.348-.344-.353-.905-.01-1.254.383-.389.516-.527.58-.59l.06-.061.352-.353.285-.285 1.551-1.55c2.116-2.12 4.3-4.31 6.446-6.469z",
    transform: "translate(0.000000, 224.000000) translate(40.000000, 16.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.ef396751f9f86afd3e5857e46acbb021.svg";
export { ForwardRef as ReactComponent };